import { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Page,
    Card,
    Text,
    // Badge,
    Icon,
    BlockStack,
    TextField,
    Modal,
    // Tabs,
    Button,
    Banner,
    DropZone,
    Pagination,
    Tooltip,
} from '@shopify/polaris';
import {
    LockMajor,
    // QuestionMarkInverseMajor,
    // MobileHorizontalDotsMajor,
    // CancelMajor,
    // ChevronDownMinor,
    // ChevronUpMinor,
    // ArrowRightMinor,
    CircleMinusMinor,
    PlusMinor
} from '@shopify/polaris-icons';
import SkeltonLoading from "../../../components/SkeltonLoading";
import {
    reqGetInstantIndexData,
    reqUpdIndexSwitch,
    reqUploadJsonFile,
    reqSubmitGoogleUrl,
    reqSaveSwitchState,
} from '../../../api';
// import Switch from "react-switch";
import { connect } from 'react-redux'
import { setSaveSwitchData } from '../../../redux/actions/getAppPublicData';
import FooterPageSelect from '../../../components/FooterPageSelect';
import HistoryTable from './components/HistoryTable';
import ApplyKeywordList from '../../../components/ApplyKeywordList';
// import SwitchAll from '../../../utils/switchState';
import utils from '../../../utils/utils';
import Language from '../../../i18n/Language';
import { store } from '../../../redux/store';
import { cloneDeep } from 'lodash';
import './index.scss';
import FaqCardBox from '../../../components/FaqCardBox';
import SaveBarTop from '../../../components/SaveBarTop';
import { setPageData } from '../../../redux/actions/getAppPageData';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
// 代码编辑器
import CodeMirror from '@uiw/react-codemirror';
import { json } from '@codemirror/lang-json';
const t = Language;

class indexClass extends Component {
    state = {
        loadingPage: true,
        isOpenState: false,
        loadingSwitch: !true,       // 开关loading
        showToastText: '',
        showToast: false,
        showToastIserror: false,
        durationTime: 5000,
        questionList: {
            ii_submit: {
                title: "After submitting the instant index, will the submitted content appear in the search results immediately?",
                tag: ["No, because even if you submit for instant indexing, Google still needs time to crawl, evaluate, and index your content, which usually takes anywhere from a few minutes to a few hours."]
            },
            ii_diff: {
                title: "What is the difference between submitting a sitemap and instant indexing? What is the difference between submitting a sitemap and instant indexing?",
                tag: ["Submitting a sitemap is to let Google understand the structure of the entire website and slowly crawl all pages. Instant indexing is to target specific pages and quickly notify Google to immediately crawl and index updated content."]
            },
            ii_index: {
                title: "If I submit a 404 link, will Google index it?",
                tag: ["No. Google will recognize that the 404 page does not exist and will not index it. It will not appear in search results."]
            },
        },           // 问题列表
        googleJsonVal: '',          // json 输入框
        jsonFocus: false,           // 聚焦
        jsonUploadShow: false,      // 弹窗状态
        tabKey: 0,                  // 索引
        submitValue: '',
        delValue: '',
        level: 1,                   // 等级
        isShowBlock: false,         // 是否展示模块
        errorJson: "",
        saveLoading: false,         // 提交loading
        isShowInput: false,
        saveBtnState: true,
        isShowAddUrlModal: false,   // 添加url弹窗状态
        submitLoading: false,
        isShowUrlDetail: false,     // url详情弹窗状态
        selectUrlArr: [],           // 选择的链接数组
        submitError: "",            // 报错提示
        delError: "",               // 报错提示
        submitBtnState: true,       // 按钮状态
        delBtnState: true,          // 按钮状态
        urlNums: 0,                 // 输入链接数量
        urlNumsDel: 0,
        tableList: [],              // 历史记录
        urlDetailList: [],          // 详情url
        isShowLimitTip: false,      // 超出提示
        isShowLimitTipDel: false,
        limits: 100,                // 限制数量
        allLimits: 200,             // 总数量
        operaType: '',              // 操作类型
        isShowFileTip: false,       // 文件类型提示
        isShowMoreAction: false,    // 指导状态
        isShowUseMain: true,
        isShowUseTop: false,
        tables: [],
        page: 1,                    // 分页
        size: 10,
        total: 0,
        current_PageSize: 10,
        hasPrevious: false,
        hasNext: false,
        domain: "",                 // 域名
        todayNum: 0,                // 每天最大量
        submitInfoState: false,
        sType: 1,
        originJsonVal: "",          // 源
        reduxLoading: true,
        isShowSaveBar: false,
    };

    componentDidMount() {
        let _store = store.getState().public;
        let _page = store.getState().page.pageInit;
        this.setState({
            level: _store.level,
            domain: store.getState().public.domain,
            isShowUseTop: typeof switchData === 'boolean' ? true : !Boolean(_store.publicInit.head_data?.switch_data?.instant_index_top)
        }, () => {
            this.getInstantIndexData(_page.InstantIndex);
        })

    }

    // 获取数据
    getInstantIndexData = async (_reduxData = null) => {
        let res = {};
        if (_reduxData) {
            res = _reduxData;
        } else {
            res = await reqGetInstantIndexData();
        }
        if (res.ack === 1) {
            if (_reduxData) {
                this.getInstantIndexData();
            }
            this.props.getPageDataRedux(res);
            let _sets = res.data.setting;
            let tables = cloneDeep(res.data.history);
            tables.forEach((item, index) => {
                item.id = index + 1;
                item.urlArr = JSON.parse(item.urls);
            })
            this.setState({
                isOpenState: Boolean(_sets?.switch),
                isShowBlock: Boolean(_sets?.switch),
                googleJsonVal: _sets?.file_content || "",
                originJsonVal: _sets?.file_content || "",
                isShowInput: Boolean(_sets?.file_content),
                todayNum: res.data.todayNum,
                tables,
                reduxLoading: Boolean(_reduxData)
            }, () => {
                this.setHistoryPage(tables);
                // this.props.changeStorePageStatus(Number(Boolean(res.data.status)));
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }

        if (res) {
            this.setState({
                loadingPage: false,
                loadingSwitch: false,
            })
        }
    }

    // 分页设置
    setHistoryPage = (data) => {
        if (data.length > 0) {
            let { page, size } = this.state;
            let tableData = data.slice((page - 1) * size, page * size);
            this.setState({
                tableList: tableData,
                total: data.length,
                hasPrevious: page > 1,
                hasNext: (page * size) < data.length
            })
        }
    }

    // 开关操作 
    handleCheckChange = () => {
        // 验证等级
        let { level } = this.state;
        if (level === 1) {
            this.props.show();
        } else {
            this.setState({
                isOpenState: !this.state.isOpenState,
                loadingSwitch: true,
            }, () => {
                let state = Number(Boolean(this.state.isOpenState));
                this.setIndexStatus(state);
            })
        }
    }

    // 保存状态
    setIndexStatus = async (val) => {
        const res = await reqUpdIndexSwitch({ switch: val });
        if (res.ack === 1) {
            this.props.toggleToast(t("Success"));
            // this.props.changeStorePageStatus(Number(Boolean(val)));
            this.setState({
                loadingSwitch: false,
                isShowBlock: Boolean(val),
            })
        } else {
            this.setState({
                isOpenState: !Boolean(val),
                loadingSwitch: false,
            })
            this.props.toggleToast(res.msg, true);
        }
    }

    // 输入
    handleValueChange = (val, type) => {
        let { limits } = this.state;
        let urls = this.formatSubmitUrl(val);
        if (urls && urls.length > limits && type === "submitValue") {
            let vals = "";
            urls.forEach((item, index) => {
                if (index < limits) {
                    vals += `${item}\n`;
                }
            })
            this.setState({
                submitBtnState: false,
                submitError: "",
                isShowLimitTip: true,
                urlNums: limits,
                [type]: vals,
            })
            return false;
        } else if (urls && urls.length > limits && type === "delValue") {
            let vals = "";
            urls.forEach((item, index) => {
                if (index < limits) {
                    vals += `${item}\n`;
                }
            })
            this.setState({
                delBtnState: false,
                delError: "",
                isShowLimitTipDel: true,
                urlNumsDel: limits,
                [type]: vals,
            })
            return false;
        } else {
            this.setState({
                [type]: val,
            }, () => {
                if (type === "googleJsonVal") {
                    this.setState({
                        errorJson: "",
                        saveBtnState: false,
                    }, () => {
                        this.checkDataChange();
                    })
                } else if (type === "submitValue") {
                    this.setState({
                        submitBtnState: false,
                        submitError: "",
                        isShowLimitTip: urls && urls.length > limits,
                        urlNums: urls ? (urls.length > limits ? limits : urls.length) : 0,
                    })
                } else if (type === "delValue") {
                    this.setState({
                        delBtnState: false,
                        delError: "",
                        isShowLimitTipDel: urls && urls.length > limits,
                        urlNumsDel: urls ? (urls.length > limits ? limits : urls.length) : 0,
                    })
                } else { }
            })
        }
    }

    // 数据对比
    checkDataChange = () => {
        let { googleJsonVal, originJsonVal } = this.state;
        this.setIsShowBarState(googleJsonVal !== originJsonVal);
    }

    // 换成输入框
    changeTextField = () => {
        // 验证等级
        let { level } = this.state;
        if (level === 1) {
            this.props.show();
        } else {
            this.setState({
                jsonFocus: true,
            })
        }
    }

    // 上传json文件
    openUploadFile = () => {
        // 验证等级
        let { level } = this.state;
        if (level === 1) {
            this.props.show();
        } else {
            this.setState({
                jsonUploadShow: true,
            })
        }
    }

    // 关闭
    closeJSONModal = () => {
        this.setState({
            jsonUploadShow: false,
        })
    }

    // 失焦
    onBlurText = () => {
        let { googleJsonVal } = this.state;
        if (!googleJsonVal) {
            this.setState({
                jsonFocus: false,
            })
        }
    }

    // 切换tabs 
    handleTabChange = (e) => {
        this.setState({
            tabKey: e,
            // submitValue: '',
            // delValue: '',
            // submitError: '',
            // delError: '',
            // submitBtnState: true,
            // delBtnState: true,

        })
    }

    // 上传json数据
    uploadJsonData = () => {
        let { level } = this.state;
        // 判断等级
        if (level === 1) {
            this.props.show();
        } else {
            this.setState({
                saveLoading: true,
            }, async () => {
                let { googleJsonVal, isShowInput } = this.state;
                const encoder = new TextEncoder();
                const jsonBytes = encoder.encode(googleJsonVal);
                const base64JSONVal = btoa(String.fromCharCode(...new Uint8Array(jsonBytes)));
                let params = {
                    content: googleJsonVal ? base64JSONVal : "",
                }
                const res = await reqUploadJsonFile(params);
                if (res.ack === 1) {
                    this.props.toggleToast(t("Success"));
                    this.setIsShowBarState(false);
                    this.setState({
                        saveLoading: false,
                        saveBtnState: true,
                        isShowInput: googleJsonVal ? isShowInput : false,
                        originJsonVal: googleJsonVal,
                    })
                } else {
                    this.setState({
                        saveLoading: false,
                        errorJson: res.msg,
                    })
                }
            })
        }
    }

    // 舍弃数据
    handleShopifyDiscard = () => {
        let { originJsonVal } = this.state;
        this.setState({
            googleJsonVal: originJsonVal,
            isShowInput: originJsonVal ? true : false,
        }, () => {
            this.setIsShowBarState(false);
            this.onBlurText();
        })
    }

    // 添加url到输入框
    addSelectUrlData = () => {
        let { selectUrlArr, submitValue, delValue, limits, urlNums, urlNumsDel, operaType } = this.state;
        if (operaType === "add" || operaType === "del") {
            let newSubmitVal = operaType === "add" ? cloneDeep(submitValue) : cloneDeep(delValue);
            let startUrls = this.formatSubmitUrl(newSubmitVal);
            if (selectUrlArr.length > 0) {
                if (urlNums >= limits && operaType === "add") {
                    this.setState({
                        isShowLimitTip: true,
                    })
                } else if (urlNumsDel >= limits && operaType === "del") {
                    this.setState({
                        isShowLimitTipDel: true,
                    })
                } else {
                    let startLens = startUrls ? startUrls.length : 0;
                    let allows = limits - startLens;
                    if (allows > 0) {
                        selectUrlArr.forEach((item, index) => {
                            if (index < allows) {
                                if (newSubmitVal === "" || newSubmitVal === "\n") {
                                    newSubmitVal = "";
                                } else {
                                    newSubmitVal = newSubmitVal.slice(newSubmitVal.length - 1) !== '\n' ? `${newSubmitVal}\n` : newSubmitVal;
                                }
                                newSubmitVal += `${item}\n`;
                            }
                        })
                        if (selectUrlArr.length > allows) {
                            this.setState(operaType === 'add' ? {
                                isShowLimitTip: true,
                            } : {
                                isShowLimitTipDel: true,
                            })
                        }
                    } else {
                        this.setState(operaType === 'add' ? {
                            isShowLimitTip: true,
                        } : {
                            isShowLimitTipDel: true,
                        })
                    }
                }
            }
            let endUrls = this.formatSubmitUrl(newSubmitVal);
            this.setState(operaType === 'add' ? {
                isShowAddUrlModal: false,
                submitValue: newSubmitVal,
                submitBtnState: false,
                submitError: "",
                selectUrlArr: [],
                urlNums: endUrls?.length || 0,
            } : {
                isShowAddUrlModal: false,
                delValue: newSubmitVal,
                delBtnState: false,
                delError: "",
                selectUrlArr: [],
                urlNumsDel: endUrls?.length || 0,
            })
        } else {
            let newDelVal = cloneDeep(delValue);
            if (newDelVal === "" || newDelVal === "\n") {
                newDelVal = "";
            } else {
                newDelVal = newDelVal.slice(newDelVal.length - 1) !== '\n' ? `${newDelVal}\n` : newDelVal;
            }
            if (selectUrlArr.length > 0) {
                selectUrlArr.forEach(item => {
                    newDelVal += `${item}\n`;
                })
            }
            this.setState({
                isShowAddUrlModal: false,
                delValue: newDelVal,
                delBtnState: false,
                delError: "",
                selectUrlArr: [],
            })
        }
    }

    // 提交或删除url
    submitGoogleUrl = (type) => {
        // 判断等级
        let { level, googleJsonVal } = this.state;
        if (level === 1) {
            this.props.show();
        } else if (googleJsonVal === '') {
            window.scrollTo(0, 0);
            this.setState(type === 'add' ? {
                submitError: "Please set the Google index API key first",
            } : {
                delError: "Please set the Google index API key first",
            })
        } else {
            this.setState({
                submitLoading: true
            }, async () => {
                let { submitValue, delValue } = this.state;
                let urlArr = type === 'add' ? this.formatSubmitUrl(submitValue) : this.formatSubmitUrl(delValue);
                if (urlArr) {
                    let params = {
                        urls: [...new Set(urlArr)],
                        type: type === 'add' ? "URL_UPDATED" : "URL_DELETED"
                    }
                    const res = await reqSubmitGoogleUrl(params);
                    if (res.ack === 1) {
                        this.props.toggleToast(t("Success"));
                        this.setState(type === 'add' ? {
                            submitBtnState: true,
                            submitValue: "",
                            urlNums: 0,
                            isShowLimitTip: false,
                        } : {
                            delBtnState: true,
                            delValue: "",
                            urlNumsDel: 0,
                            isShowLimitTipDel: false,
                        })
                    } else {
                        this.setState(type === 'add' ? {
                            submitError: res.msg,
                        } : {
                            delError: res.msg,
                        })
                    }

                    if (res) {
                        this.setState({
                            submitLoading: false,
                        }, () => {
                            this.getInstantIndexData();
                        })
                    }
                } else {
                    let errorInfo = "Please ensure that the URL you entered is in the correct format";
                    this.setState(type === 'add' ? {
                        submitError: errorInfo,
                        submitLoading: false,
                    } : {
                        delError: errorInfo,
                        submitLoading: false,
                    })
                }
            })
        }
    }

    // 格式化链接数据
    formatSubmitUrl = (data) => {
        let urlArr = [];
        if (data.indexOf('https://') > -1) {
            data.split('\n').forEach(item => {
                if (item && item !== '\n' && item.indexOf('https://') > -1) {
                    urlArr.push(item)
                }
            })
            return urlArr;
        } else {
            return false;
        }
    }

    // 选中数据
    changeSelectApply = (data, lists) => {
        let selectUrlArr = [];
        let compares = {
            "Products": "products",
            "Homepage": "",
            "Collections": "collections",
            "Blogs": "blogs",
            "Other Pages": "pages",
        }
        let domain = store.getState().public.domain;
        Object.keys(data).forEach(item => {
            let dataArr = data[item];
            if (dataArr.length > 0) {
                if (item === "Homepage") {
                    selectUrlArr.push(`https://${domain}`);
                } else {
                    if (lists[item].list.length > 0) {
                        dataArr.forEach(id => {
                            let objs = lists[item].list.filter(obj => obj.id === id);
                            if (objs.length > 0) {
                                selectUrlArr.push(
                                    item === "Blogs" ? `https://${domain}/${compares[item]}/${objs[0].blog_handle}/${objs[0].handle}` :
                                        `https://${domain}/${compares[item]}/${objs[0].handle}`
                                );
                            }
                        })
                    }
                }
            }
        })
        this.setState({
            selectedArr: data,
            selectUrlArr,
        })
    }

    // 打开添加url弹窗
    openAddUrlModal = (type) => {
        // 判断等级
        let { level } = this.state;
        if (level === 1) {
            this.props.show();
        } else {
            this.setState({
                operaType: type,
                isShowAddUrlModal: true
            })
        }
    }

    // 关闭添加
    closeAddUrlModal = () => {
        this.setState({
            isShowAddUrlModal: false
        })
    }

    // 打开url详情
    openUrlDetail = (urls) => {
        this.setState({
            isShowUrlDetail: true,
            urlDetailList: urls,
        })
    }

    // 关闭url详情弹窗
    closeUrlDetailModal = () => {
        this.setState({
            isShowUrlDetail: false,
        })
    }

    // 上传文件内容
    handleDropZoneDrop = (file) => {
        let objs = file[0].type;
        if (objs.indexOf('json') > -1) {
            const reader = new FileReader();
            reader.onload = function (e) {
                try {
                    this.setIsShowBarState(true);
                    this.setState({
                        googleJsonVal: e.target.result,
                        isShowInput: true,
                        jsonUploadShow: false,
                        saveBtnState: false,
                    })
                } catch (error) {
                    this.setState({
                        isShowFileTip: error,
                    })
                }
            }.bind(this);  // 使用 bind 绑定 this;
            reader.readAsText(file[0]);
        } else {
            this.setState({
                isShowFileTip: "The file must be JSON",
            })
        }
    }

    // 关闭
    changeToUsePop = () => {
        this.setState({
            isShowMoreAction: !this.state.isShowMoreAction,
        })
    }

    // 打开内容
    handleUseMain = () => {
        this.setState({
            isShowUseMain: !this.state.isShowUseMain,
        })
    }

    // 滚到模块
    scrollToBlock = (id) => {
        let objs = document.getElementById(id);
        if (objs?.getBoundingClientRect) {
            window.scrollTo(0, objs.getBoundingClientRect().top - 100, "smooth");
        }
    }

    // 关闭指导
    handleDismiss = (type) => {
        this.setState({
            isShowUseTop: false,
        }, async () => {
            this.requestStateSet(type);
        })
    }

    // 选择表格条数
    changePageSize = (e) => {
        this.setState({
            page: 1,
            size: Number(e),
            current_PageSize: Number(e),
        }, () => {
            this.setHistoryPage(this.state.tables);
        })
    }

    // 切换分页
    changePageTable = (page) => {
        this.setState(({
            page,
        }), () => {
            this.setHistoryPage(this.state.tables);
        });
    }

    // 发送请求
    requestStateSet = async (type, st = 0) => {
        const params = {
            name: `${type}`,
            st: st,
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data);
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": st, "exp": 0 };
            this.props.setSwitchData(data);
        } else {
            this.props.toggleToast(t("Try again later"), true)
        }
    }

    // 返回
    goBack = () => {
        utils.routeJump(this, '/searchAppearance')
    }

    // 跳转指定链接
    jumpUrl = (type) => {
        const urlArr = [
            "/plan",
        ]
        let url = urlArr[type];
        utils.routeJump(this, url)
    }

    // 关闭提交弹窗
    toggleSubmitInfo = () => {
        let { submitInfoState } = this.state;
        this.setState({
            submitInfoState: !submitInfoState,
            isShowLimitTip: "",
            submitError: "",
        })
    }

    // 打开提交
    openSubmitModal = (type) => {
        let { level } = this.state;
        if (level === 1) {
            this.props.show();
        } else {
            this.setState({
                sType: type,
                submitInfoState: true,
            })
        }
    }

    // 设置savebar状态
    setIsShowBarState = (_state) => {
        window.savebarState = _state;
        this.setState({
            isShowSaveBar: _state
        })
    }

    // 跳转指导
    jumpGuideUrl = () => {
        window.open("https://www.seoant.com/blog/instant-indexing-operations-guide")
    }

    render() {
        const {
            state: {
                loadingPage,
                // isOpenState,
                // loadingSwitch,
                googleJsonVal,
                jsonFocus,
                jsonUploadShow,
                // tabKey,
                submitValue,
                delValue,
                level,
                // isShowBlock,
                errorJson,
                saveLoading,
                isShowInput,
                // saveBtnState,
                isShowAddUrlModal,
                submitLoading,
                isShowUrlDetail,
                submitError,
                delError,
                submitBtnState,
                delBtnState,
                urlNums,
                urlNumsDel,
                selectUrlArr,
                tableList,
                urlDetailList,
                isShowLimitTip,
                limits,
                allLimits,
                isShowFileTip,
                isShowLimitTipDel,
                // isShowMoreAction,
                // isShowUseMain,
                // isShowUseTop,
                page,
                size,
                total,
                current_PageSize,
                hasPrevious,
                hasNext,
                // domain,
                questionList,
                todayNum,
                submitInfoState,
                sType,
                isShowSaveBar,
                originJsonVal,
                reduxLoading,

            },

        } = this;

        // 升级icon
        const lockIcon = () => {
            return <div className='PAY_ICON' onClick={() => this.jumpUrl(0)}>
                {t("Pro plan unlock")} <Icon source={LockMajor} tone="base" />
            </div>
        }

        // 提交弹窗
        const submitInfoModal = <Modal
            open={submitInfoState && !isShowAddUrlModal}
            title={t("Submit instant index")}
            primaryAction={{
                content: sType === 1 ? t("Submit to Google") : t("Remove from Google"),
                onAction: () => this.submitGoogleUrl(sType === 1 ? 'add' : 'del'),
                loading: submitLoading,
                disabled: (sType === 1 && (!submitValue || submitBtnState)) || (sType === 2 && (!delValue || delBtnState))
            }}
            secondaryActions={[
                {
                    content: t("Cancel"),
                    onAction: () => this.toggleSubmitInfo()
                }
            ]}
            onClose={() => this.toggleSubmitInfo()}
        >
            <Modal.Section>
                {
                    (sType === 1 && isShowLimitTip) || (sType === 2 && isShowLimitTipDel) ? <Banner
                        tone="warning"
                        title={t("The limit of 100 has been reached and no more can be added")}
                        onDismiss={() => {
                            this.setState(sType === 1 ? { isShowLimitTip: false } : { isShowLimitTipDel: false })
                        }}
                    ></Banner> : null
                }
                <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                    <p>{`${t("List of URL")}`}</p>
                    {
                        sType === 1 ? <Button variant='plain' onClick={() => this.openAddUrlModal('add')} disabled={submitLoading || urlNums >= limits}>{t("Add URL")}</Button> : <Button variant='plain' onClick={() => this.openAddUrlModal('del')} disabled={submitLoading || urlNumsDel >= limits}>{t("Add URL")}</Button>
                    }
                </div>
                <TextField
                    id={sType === 1 ? "submitValue" : "delValue"}
                    value={sType === 1 ? submitValue : delValue}
                    onChange={this.handleValueChange}
                    multiline={2}
                    maxHeight={'200px'}
                    placeholder={t("E.g: https//shopify.com/products1, Each url is separated by lines.")}
                    autoComplete="off"
                    disabled={submitLoading}
                    error={sType === 1 ? submitError : delError}
                />
                {
                    sType === 1 ?
                        <BlockStack gap={0}>
                            <Text as="p" tone="subdued">{t("Each url is separated by lines.")}</Text>
                            <Text as="p" tone="subdued">{t("Submit up to")} <span style={{ color: urlNums === limits ? '#f60b0b' : '' }}>{urlNums}</span>/{limits} {t("URL each time. Submit up to")} <span style={{ color: todayNum === allLimits ? '#f60b0b' : '' }}>{todayNum}</span>/{allLimits}&nbsp;{t("URL per day")}.</Text>
                        </BlockStack> :
                        <BlockStack gap={0}>
                            <Text as="p" tone="subdued">{t("Each url is separated by lines.")}</Text>
                            <Text as="p" tone="subdued">{t("Submit up to")} <span style={{ color: urlNumsDel === limits ? '#f60b0b' : '' }}>{urlNumsDel}</span>/{limits} {t("URL each time. Submit up to")} <span style={{ color: todayNum === allLimits ? '#f60b0b' : '' }}>{todayNum}</span>/{allLimits}&nbsp;{t("URL per day")}.</Text>
                        </BlockStack>
                }
            </Modal.Section>
        </Modal>

        // 分页
        const wwidth = window.innerWidth; // 屏幕宽度
        let footerContentMsg = "";
        if (total > 0) {
            const startNum = (page - 1) * size + 1;
            const endNum = page * size > total ? total : page * size;
            footerContentMsg = wwidth >= 550 ? <FooterPageSelect changePageSize={this.changePageSize} startNum={startNum} endNum={endNum} total={total} current_PageSize={current_PageSize} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);
        }

        // json上传弹窗
        const JSONModal = <Modal
            title={t("Upload the Google JSON key file")}
            open={jsonUploadShow}
            primaryAction={{
                content: t("Add"),

            }}
            onClose={this.closeJSONModal}
        >
            <Modal.Section>
                <BlockStack gap={200}>
                    {
                        isShowFileTip && <Banner
                            tone="warning"
                            title={t(isShowFileTip)}
                            onDismiss={() => {
                                this.setState({ isShowFileTip: "" })
                            }}
                        >
                        </Banner>
                    }
                    <DropZone
                        accept=".json"
                        onDrop={this.handleDropZoneDrop}
                        variableHeight
                    >
                        <DropZone.FileUpload actionHint={t("Accepts .json")} />
                    </DropZone>
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 添加url弹窗
        const AddUrlModal = <Modal
            title={t("Select URL")}
            open={isShowAddUrlModal}
            primaryAction={{
                content: t("Add"),
                onAction: this.addSelectUrlData,
                disabled: selectUrlArr.length === 0
            }}
            secondaryActions={{
                content: t("Cancel"),
                onAction: this.closeAddUrlModal
            }}
            onClose={this.closeAddUrlModal}
        >
            <ApplyKeywordList
                mode="multiple"
                isNotShowTitle={true}
                applyKeywordVal={""}
                changeSelectApply={this.changeSelectApply}
            />
        </Modal>

        // url详情弹窗
        const UrlDetailModal = <Modal
            title={t("Submitted URL")}
            open={isShowUrlDetail}
            primaryAction={{
                content: t("OK"),
                onAction: this.closeUrlDetailModal
            }}
            onClose={this.closeUrlDetailModal}
        >
            <Modal.Section>
                <div className='url_detail_modal'>
                    {
                        urlDetailList.map((item, index) => {
                            return <p key={`${item}-${index}`}
                                className='url_items'
                            >
                                <span>{item}</span>
                            </p>
                        })
                    }
                </div>
            </Modal.Section>
        </Modal>


        // // 顶部开关
        // const TopSwitchBlock = (!isShowBlock || level === 1) && <Card>
        //     <div className='instant_index_top'>
        //         <div className='boost_index'>
        //             <Text variant="headingMd" as="h2">{t("Instant index")}</Text>
        //             {
        //                 (isOpenState && level > 1) ? <Badge tone='success'>{t("On")}</Badge> :
        //                     <Badge>{t("Off")}</Badge>
        //             }
        //             {level === 1 && lockIcon()}
        //             <div className='b_switch'>
        //                 {loadingSwitch && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
        //                 <Switch disabled={loadingSwitch} onChange={this.handleCheckChange} checked={isOpenState && level > 1} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
        //             </div>
        //         </div>
        //         <p>
        //             {t("Instant indedx can quickly inform Google of pages added or removed from a site, which is useful for sites that are frequently updated.")}&nbsp;
        //             <span className='jump_text' onClick={() => {
        //                 window.open("https://www.seoant.com/blog/instant-indexing-operations-guide")
        //             }}>{t("Operation guide")}</span>
        //         </p>
        //     </div>
        // </Card>

        // 指导模块
        // const HowToUse = (isShowBlock && isShowUseTop) && <Card>
        //     <div className='use_top'>
        //         <BlockStack gap={100}>
        //             <Text variant="headingMd" as="h2">{t("How to use")}</Text>
        //         </BlockStack>
        //         <div className='use_url'><Button variant='plain' onClick={() => {
        //             window.open("https://www.seoant.com/blog/instant-indexing-operations-guide")
        //         }}>{t("Operation guide")}</Button></div>
        //         <div className='guide_opera'>
        //             <Popover
        //                 active={isShowMoreAction}
        //                 activator={<div onClick={this.changeToUsePop}><Icon color='base' source={MobileHorizontalDotsMajor} /></div>}
        //                 onClose={this.changeToUsePop}
        //             >
        //                 <ActionList
        //                     actionRole="menuitem"
        //                     items={[
        //                         {
        //                             content: t("Dismiss"),
        //                             onAction: () => this.handleDismiss(SwitchAll['ii_useTop']),
        //                             icon: CancelMajor
        //                         },
        //                     ]}
        //                 />
        //             </Popover>
        //             <div onClick={this.handleUseMain}><Icon color='base' source={!isShowUseMain ? ChevronDownMinor : ChevronUpMinor} /></div>
        //         </div>
        //     </div>
        //     <Collapsible
        //         id="HowToUseInstant"
        //         open={isShowUseMain}
        //     >
        //         <div className='how_to_use'>
        //             <div className='use_item' onClick={() => this.scrollToBlock("API_SAVE")}>
        //                 <div className='flex_layout'>
        //                     <Text variant="headingMd" as="h2">{t("Setting")}</Text>
        //                     <span><Icon source={ArrowRightMinor} /></span>
        //                 </div>
        //                 <Text as="p" tone="subdued">{t("Add Google index APl key")}</Text>
        //             </div>
        //             <div className='use_item' onClick={() => this.scrollToBlock("SUBMIT_BTN")}>
        //                 <div className='flex_layout'>
        //                     <Text variant="headingMd" as="h2">{t("Submit or delete")}</Text>
        //                     <span><Icon source={ArrowRightMinor} /></span>
        //                 </div>
        //                 <Text as="p" tone="subdued">{t("Submit/delete pages to Google for indexing")}</Text>
        //             </div>
        //             <div className='use_item' onClick={() => this.scrollToBlock("HISTORY_DATA")}>
        //                 <div className='flex_layout'>
        //                     <Text variant="headingMd" as="h2">{t("History record")}</Text>
        //                     <span><Icon source={ArrowRightMinor} /></span>
        //                 </div>
        //                 <Text as="p" tone="subdued">{t("View the history of submitting/delete URLs to Google")}</Text>
        //             </div>
        //         </div>
        //     </Collapsible>
        // </Card>

        // Setting模块
        const settingCard = <BlockStack gap={400}>
            {/* <div id='API_SAVE'></div> */}
            {/* <Text variant="headingLg" as="h2">{t("Setting")}</Text> */}
            <SaveBarTop
                isShowSaveBar={isShowSaveBar}
                saveLoading={saveLoading}
                handleSaveAction={this.uploadJsonData}
                handleDiscardAction={this.handleShopifyDiscard}
            />
            <Card>
                <BlockStack gap={200}>
                    <div>
                        <Text variant="headingMd" as="h2">{t("Google index APl key")}</Text>
                        <Text as="p" tone="subdued" variant='bodyMd'><span className='jump_text' onClick={this.jumpGuideUrl}>{t("View the")}&nbsp;{t("guide")}&nbsp;</span>{t("to learn how to obtain the key")}</Text>
                    </div>
                    <div className='CodeMirror_Box'>
                        {
                            (jsonFocus || isShowInput) ? <CodeMirror
                                id="googleJsonVal"
                                height="260px"
                                theme="light"
                                extensions={[json()]}
                                value={googleJsonVal}
                                onChange={(val) => this.handleValueChange(val, "googleJsonVal")}
                                onBlur={this.onBlurText}
                                readOnly={saveLoading}
                                autoFocus={jsonFocus}
                            /> : <div className='upload_file_copy' onClick={this.changeTextField}>
                                <span>
                                    {t("Enter the content of the json file you downloaded from Google, or")}&nbsp;
                                    <span className='jump_text' onClick={(e) => {
                                        e.stopPropagation();
                                        this.openUploadFile();
                                    }}>{t("upload the json file")}</span>
                                </span>
                            </div>
                        }
                    </div>
                    {/* {
                        jsonFocus || isShowInput ? <div style={{ minHeight: '170px' }}>
                            <TextField
                                id="googleJsonVal"
                                value={googleJsonVal}
                                onChange={this.handleValueChange}
                                multiline={8}
                                maxHeight={'160px'}
                                focused={jsonFocus}
                                onBlur={this.onBlurText}
                                autoComplete="off"
                                error={t(errorJson)}
                                disabled={saveLoading}
                            />
                        </div> : <div className='upload_file_copy' onClick={this.changeTextField}>
                            <span>
                                {t("Enter the content of the json file you downloaded from Google, or")}&nbsp;
                                <span className='jump_text' onClick={(e) => {
                                    e.stopPropagation();
                                    this.openUploadFile();
                                }}>{t("upload the json file")}</span>
                            </span>
                        </div>
                    } */}
                    {/* <div><Button variant='primary' loading={saveLoading} disabled={saveBtnState} onClick={this.uploadJsonData}>{t("Save")}</Button></div> */}
                </BlockStack>
            </Card>
        </BlockStack>

        // 提交和删除模块
        // const SubmitOrDel = isShowBlock && <BlockStack gap={400}>
        //     <Text variant="headingLg" as="h2">{t("Submit or delete")}</Text>
        //     <Card>
        //         <BlockStack gap={200}>
        //             <div className='tabs_top'>
        //                 <Tabs tabs={[
        //                     {
        //                         id: 'Submit-index',
        //                         content: t("Submit instant index"),
        //                     },
        //                     {
        //                         id: 'Submit-delete',
        //                         content: t("Submit to delete"),
        //                     }
        //                 ]} selected={tabKey} onSelect={this.handleTabChange}></Tabs>
        //             </div>
        //             {
        //                 tabKey === 0 ? <>
        //                     <div className='flex_layout'>
        //                         <p>{t("Add the website page you want to submit")}:</p>
        //                         <div><Button onClick={() => this.openAddUrlModal('add')} disabled={submitLoading || urlNums >= limits}>{t("Add URL")}</Button></div>
        //                     </div>
        //                     {
        //                         isShowLimitTip && <Banner
        //                             tone="warning"
        //                             title={t("The limit of 100 has been reached and no more can be added")}
        //                             onDismiss={() => {
        //                                 this.setState({ isShowLimitTip: false })
        //                             }}
        //                         ></Banner>
        //                     }
        //                     <TextField
        //                         label={`${t("List of URL")}:`}
        //                         id="submitValue"
        //                         value={submitValue}
        //                         onChange={this.handleValueChange}
        //                         multiline={2}
        //                         maxHeight={'200px'}
        //                         placeholder={t("E.g: https://shopify.com/products1")}
        //                         autoComplete="off"
        //                         disabled={submitLoading}
        //                         error={submitError}
        //                     />
        //                     <BlockStack gap={0}>
        //                         <Text as="p" tone="subdued">{t("Each url is separated by lines.")}</Text>
        //                         <Text as="p" tone="subdued">{t("Submit up to")} <span style={{ color: urlNums === limits ? '#f60b0b' : '' }}>{urlNums}</span>/{limits} {t("URL each time. Submit up to")} <span style={{ color: todayNum === allLimits ? '#f60b0b' : '' }}>{todayNum}</span>/{allLimits}&nbsp;{t("URL per day")}.</Text>
        //                     </BlockStack>
        //                 </> : <>
        //                     <div className='flex_layout'>
        //                         <p>{t("Add the website page you want to delete")}:</p>
        //                         <div><Button onClick={() => this.openAddUrlModal('del')} disabled={submitLoading || urlNumsDel >= limits}>{t("Add URL")}</Button></div>
        //                     </div>
        //                     {
        //                         isShowLimitTipDel && <Banner
        //                             tone="warning"
        //                             title={t("The limit of 100 has been reached and no more can be added")}
        //                             onDismiss={() => {
        //                                 this.setState({ isShowLimitTipDel: false })
        //                             }}
        //                         ></Banner>
        //                     }
        //                     <TextField
        //                         label={`${t("List of URL")}:`}
        //                         id="delValue"
        //                         value={delValue}
        //                         onChange={this.handleValueChange}
        //                         multiline={2}
        //                         maxHeight={'200px'}
        //                         placeholder={t("E.g: https://shopify.com/products2")}
        //                         autoComplete="off"
        //                         error={delError}
        //                         disabled={submitLoading}
        //                     />
        //                     <BlockStack gap={0}>
        //                         <Text as="p" tone="subdued">{t("Each url is separated by lines.")}</Text>
        //                         <Text as="p" tone="subdued">{t("Submit up to")} <span style={{ color: urlNumsDel === limits ? '#f60b0b' : '' }}>{urlNumsDel}</span>/{limits} {t("URL each time. Submit up to")} <span style={{ color: todayNum === allLimits ? '#f60b0b' : '' }}>{todayNum}</span>/{allLimits}&nbsp;{t("URL per day")}.</Text>
        //                     </BlockStack>
        //                     <div>
        //                         <Button variant='primary' loading={submitLoading} disabled={!delValue || delBtnState} onClick={() => this.submitGoogleUrl('del')}>{t("Submit to delete")}</Button>
        //                     </div>
        //                 </>
        //             }
        //         </BlockStack>
        //     </Card>
        // </BlockStack>

        // 历史记录表
        const historyTable = <BlockStack gap={400}>
            {/* <div id='HISTORY_DATA'></div> */}
            <div className='history_top'>
                {/* <div className='flex_layout'>
                    <Text variant="headingMd" as="h2">{t("Submission history")}</Text>
                    {level === 1 && lockIcon()}
                </div> */}
                {/* <Button variant='plain' onClick={() => {
                    window.open(`https://search.google.com/search-console/index?resource_id=sc-domain%3A${domain}`)
                }}>{t("Open GSC to view Index detail")}</Button> */}
                <div className='flex_layout'>
                    {
                        !originJsonVal ? <>
                            <Tooltip content={<div>
                                <span>{t("Please set the Google index API key first")}</span>.&nbsp;
                                <a href="https://www.seoant.com/blog/instant-indexing-operations-guide" target='_blank' className='jump_text'>{t("View the")}&nbsp;{t("guide")}&nbsp;</a>
                            </div>}>
                                <Button disabled={!originJsonVal} loading={reduxLoading} icon={CircleMinusMinor} tone='base'>{t("Submit to delete")}</Button>
                            </Tooltip>
                            <Tooltip content={<div>
                                <span>{t("Please set the Google index API key first")}</span>.&nbsp;
                                <a href="https://www.seoant.com/blog/instant-indexing-operations-guide" target='_blank' className='jump_text'>{t("View the")}&nbsp;{t("guide")}&nbsp;</a>
                            </div>}>
                                <Button disabled={!originJsonVal} loading={reduxLoading} variant='primary' icon={PlusMinor} tone='base'>{t("Submit instant index")}</Button>
                            </Tooltip>
                        </> : <>
                            <Button onClick={() => this.openSubmitModal(2)} disabled={!originJsonVal} loading={reduxLoading} icon={CircleMinusMinor} tone='base'>{t("Submit to delete")}</Button>
                            <Button onClick={() => this.openSubmitModal(1)} disabled={!originJsonVal} loading={reduxLoading} variant='primary' icon={PlusMinor} tone='base'>{t("Submit instant index")}</Button>
                        </>
                    }
                </div>
            </div>
            <Card padding={0}>
                <BlockStack gap={200}>
                    <div className='flex_layout' style={{ padding: '1rem 1rem 0' }}>
                        <Text variant="headingMd" as="h2">{t("Submission history")}</Text>
                        {level === 1 && lockIcon()}
                    </div>
                    <div>
                        <HistoryTable
                            tableList={tableList}
                            openUrlDetail={this.openUrlDetail}
                        />
                        {
                            tableList.length > 0 && <div className={`justify_center ${current_PageSize > 5 ? 'sticky_footer' : ''}`}>
                                <Pagination
                                    label={footerContentMsg}
                                    hasPrevious={hasPrevious}
                                    onPrevious={() => this.changePageTable(page - 1)}
                                    hasNext={hasNext}
                                    onNext={() => this.changePageTable(page + 1)}
                                />
                            </div>
                        }
                    </div>
                </BlockStack>
            </Card>
        </BlockStack>

        // 常见问题
        const FrequentlyItems = <FaqCardBox FaqList={questionList} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const pageContent = !loadingPage ? <Page
        // title={
        //     <div className='pageLayout' style={{ display: "flex", alignItems: "center" }}>
        //         {t("Instant Index")}
        //         <label style={{ cursor: 'pointer' }} onClick={() => {
        //             window.open("https://www.seoant.com/blog/instant-indexing-operations-guide")
        //         }}>
        //             <Tooltip content={
        //                 <p>
        //                     {t("Instant indedx can quickly inform Google of pages added or removed from a site, which is useful for sites that are frequently updated.")}&nbsp;
        //                     <span className='jump_text'>{t("Operation guide")}</span>
        //                 </p>
        //             }>
        //                 {<Icon backdrop source={QuestionMarkInverseMajor} />}
        //             </Tooltip>
        //         </label>
        //     </div>
        // }
        // backAction={{
        //     content: t("Instant Index"),
        //     onAction: this.goBack,
        // }}
        >
            <div className='instant_index'>
                <title>SEOAnt - Instant Index</title>
                <BlockStack gap={400}>
                    {historyTable}
                    {/* {TopSwitchBlock} */}
                    {/* {HowToUse} */}
                    {settingCard}
                    {/* {SubmitOrDel} */}
                    {FrequentlyItems}
                </BlockStack>
                {JSONModal}
                {AddUrlModal}
                {UrlDetailModal}
                {submitInfoModal}
                {/* 底部 */}
                {FooterHelpBox}
            </div>
        </Page> : <SkeltonLoading />;


        return pageContent;
    }

}

// 验证数据格式
// function verifyJson(data) {
//     try {
//         JSON.parse(data);
//         return true;
//     } catch (e) {
//         return false;
//     }
// }

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['InstantIndex', data]));
    },

})

indexClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);
